import styled from '@emotion/styled';
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  SelectChangeEvent,
  SxProps,
} from '@mui/material';
import React from 'react';

interface Option {
  value: string;
  label: string | JSX.Element;
  disabled?: boolean;
}

interface CustomSelectProps {
  options: Option[];
  value?: string;
  onChange: (value: string) => void;
  height?: string;
  sx?: SxProps;
  label?: string;
}

const CustomSelectContainer = styled(Select)({
  width: '100%',
  minHeight: 40,
  maxHeight: 40,
  borderRadius: 5,
  backgroundColor: '#fff',
  border: '1px solid #ccc',
  '&:focus': {
    backgroundColor: '#fff',
  },
  '& .MuiSelect-selectMenu': {
    height: 'auto',
    minHeight: '40px!important',
  },
});

const CustomLabel = styled(InputLabel)({
  color: '#00000087 !important',
  fontSize: '14px',
  transform: 'translate(14px, -50%) !important',
  top: '50%',
  '&.Mui-focused, &.MuiInputLabel-shrink': {
    transform: 'translate(14px, -140%) scale(0.75) !important',
    backgroundColor: 'white',
    padding: '0 4px',
  },
});

const CustomMenuItem = styled(MenuItem)({
  fontSize: 14,
  height: 40,
});

export const SortSelect: React.FC<CustomSelectProps> = ({
  options,
  value = [],
  onChange,
  height,
  sx,
  label = 'Sort by',
}) => {
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const selectedValues = event.target.value as string;
    onChange(selectedValues);
  };

  return (
    <FormControl variant="outlined" sx={{ minWidth: '140px', ...sx }}>
      <CustomLabel>{label}</CustomLabel>
      <CustomSelectContainer
        value={value}
        onChange={handleChange}
        sx={{ height: height ? `${height} !important` : undefined }}
        renderValue={(selected) => {
          const selectedLabel = options.find(
            (o) => o.value === selected
          )?.label;
          return selectedLabel;
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200,
              maxWidth: '120px',
            },
          },
        }}
      >
        {options.map((option) => (
          <CustomMenuItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </CustomMenuItem>
        ))}
      </CustomSelectContainer>
    </FormControl>
  );
};
